import { FormValues } from 'pages/MerchantPages/Assets/Preview';

export const transformMetadataForUpdate = (data: FormValues, initialValues: FormValues) => {
  const metadataForUpdate: Array<any> = [];
  Object.keys(data).forEach((key) => {
    const initialValue = initialValues[key];
    const currentValue = data[key];

    if (initialValue !== currentValue) {
      metadataForUpdate.push({ key, value: currentValue });
    }
  });

  return metadataForUpdate.reduce(
    (acc, cur) => ({
      ...acc,
      [cur.key]: cur.value,
    }),
    {}
  );
};
